module.exports = __webpack_public_path__ + "media/images/mobile/solutions/12-d15d5bbba920fb7c8ae8c5bb660ed82c.png";